<div class="inner-sidebar__brand-row flex items-center justify-between gap-2">
  <div class="branding min-w-0 flex-1">
    <app-branding></app-branding>
  </div>

  @if (showCollapseToggle) {
    <button
      type="button"
      class="inner-sidebar__collapse"
      (click)="toggleCollapsed.emit()"
      [attr.aria-label]="'layout.collapseSidebar' | translate"
      [attr.title]="'layout.collapseSidebar' | translate"
    >
      <span
        class="iconify text-lg inner-sidebar__collapse-icon"
        data-icon="solar:alt-arrow-left-linear"
        aria-hidden="true"
      ></span>
    </button>
  }

  @if (showToggle) {
    <button
      type="button"
      (click)="toggleMobileNav.emit()"
      class="overlay-nav-close flex justify-center items-center"
      [attr.aria-label]="'layout.closeMenu' | translate"
    >
      <i-tabler name="x" class="flex"></i-tabler>
    </button>
  }
</div>
